import { put } from 'redux-saga/effects';
import { foldersModel } from '../../../features/folders';
import { pagesModel } from '../../../features/pages';

export function* workspaceSaga() {
  yield put(foldersModel.actions.setCurrentFolder(undefined));
  yield put(pagesModel.actions.setCurrentPage(undefined));
  yield put(pagesModel.actions.setCurrentContentId(undefined));
}
